import { render, staticRenderFns } from "./ModalCreatePassword.vue?vue&type=template&id=d6a9e44c&"
import script from "./ModalCreatePassword.vue?vue&type=script&lang=js&"
export * from "./ModalCreatePassword.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreatePassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports